module.exports = __webpack_public_path__ + "static/media/meeting-board.3231ac23.svg";